import * as yup from 'yup';

import { AccountUse, ApplicationType, OrganizationType, accountUseIsOrg } from './types';

export const nameValidator = yup
  .string()
  .min(2, 'Name is too short')
  .max(60, 'Name is too long')
  .required('Required')
  .label('Name');

export const emailValidator = yup
  .string()
  .email('Invalid email')
  .required('Required')
  .label('Email');

export const accountUseValidator = yup
  .string()
  .oneOf(Object.values(AccountUse))
  .required('Required')
  .label('Account Use');

export const accountUseOtherValidator = yup
  .string()
  .min(2, 'Account Use is too short')
  .max(60, 'Account Use is too long')
  .label('Account Use')
  .when('use', {
    is: (use: AccountUse) => use === AccountUse.other,
    then: yup.string().required('Required'),
  });

export const organizationNameValidator = yup
  .string()
  .min(2, 'Organization name is too short')
  .max(60, 'Organization name is too long')
  .label('Organization name')
  .when('use', {
    is: (use: AccountUse) => accountUseIsOrg(use),
    then: yup.string().required('Required'),
  });

export const organizationTypeValidator = yup
  .string()
  .oneOf(Object.values(OrganizationType))
  .required('Required')
  .label('Organization type');

export const appNameValidator = yup
  .string()
  .min(2, 'Application name is too short')
  .max(60, 'Application name is too long')
  .required('Required')
  .label('Application name');

export const appDescriptionValidator = yup
  .string()
  .min(2, 'Application description is too short')
  .max(480, 'Application description is too long')
  .label('Application description')
  .when('type', {
    is: (appType: string) => appType === ApplicationType.other,
    then: yup.string().required('Required'),
  });

export const appTypeValidator = yup
  .string()
  .oneOf(Object.values(ApplicationType))
  .required('Required')
  .label('Application type');

export const dblTokenValidator = yup
  .string()
  .test('length', 'Must be 20 characters', (value) => !value || value.length === 20)
  .label('DBL token');

export const authorizedBiblesValidator = yup
  .string()
  .test(
    'array item length',
    'Must be a comma-delimited list of 16 characters',
    (value) =>
      !value ||
      (!value.includes(',') && value.length === 16) ||
      value.split(',').every((item) => item.length === 16),
  )
  .label('Authorized Bibles');

export const planCountLimitValidator = yup.number().min(0, 'Must be 0 (for unlimited) or greater');
